import React, { useCallback, useEffect, useRef, useState } from 'react';

import 'styled-components/macro';
import styled, { css } from 'styled-components/macro';
import constantes from '../../resources/constantes.json';
import { withRouter } from 'react-router-dom';
import { FiClock, FiSearch } from 'react-icons/fi';
import { useNomenclator } from '../../contexts/nomenclatorContext.js';
import InlineDialog from '../InlineDialog';
import { usePage } from '../../contexts/pageContext';
import { useViewContext, useMesa } from 'contexts/viewContext';
import RoundButton from '../Botones/RoundButton';
import { responsive } from '../../resources/constantes.json';
import LinkWithTop from '../Links/LinkWithTop';
import Buscador from '../../components/Buscador';
import useOutsideClick from '../../hooks/useOutsideClick';
import { consultarBusquedasLocalStorage } from '../../commons/js/util';
import getDataFavoritos from '../../utils/getDataFavoritos';
import { useTranslate } from '../../contexts/languageContext';
import useIni from '../../hooks/useIni';

const BuscadorSideBar = withRouter(() => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const ini = useIni();

  const { urlInfo } = pageState;
  const { page } = urlInfo;
  const { view, esHistorico } = useViewContext();
  const { setMesa } = useMesa();

  const elec = constantes.eleccion[page];

  const [isSearchInputOpen, setIsSearchInputOpen] = useState(false);
  const setOpenFalse = useCallback(() => setIsSearchInputOpen(false), []);
  const miDivRef = useOutsideClick(setOpenFalse);
  const inputRef = useRef(null);

  const handleBlur = useCallback(e => {
    const currentTarget = e.currentTarget;

    // Give browser time to focus the next element
    requestAnimationFrame(() => {
      // Check if the new focused element is a child of the original container
      if (!currentTarget.contains(document.activeElement)) {
        setIsSearchInputOpen(false);
      }
    });
  }, []);

  useEffect(() => {
    const el = inputRef.current;
    if (isSearchInputOpen && el) {
      el.focus();
    }
  }, [isSearchInputOpen]);

  const busquedas = consultarBusquedasLocalStorage(
    constantes.nombreEleccion[elec]
  );
  const busquedasSugeridas = ini.busquedasSugeridas;

  return (
    <>
      {view && view !== 'estadisticas' && (
        <>
          <SearchButtonContainer ref={miDivRef} onBlur={handleBlur}>
            <RoundButton
              label={t('buscar')}
              disabled={
                elec === undefined || view === 'estadisticas' || esHistorico
              }
              onClick={() => {
                setIsSearchInputOpen(!isSearchInputOpen);
              }}
            >
              <FiSearch style={{ width: '50%', height: '50%' }} />
            </RoundButton>
            {nomenclator && isSearchInputOpen && elec && (
              <ContenedorModalFlecha>
                <StyledInlineDialog
                  isSearchInputOpen={isSearchInputOpen}
                  onClose={e => {
                    //setTimeout para que si le damos al OpenButton non se cierrre y se abra instantaneamente
                    //TODO: comprobar que este truco funciona en todos los navegadores (Firefox y Chrome Ok).
                    setTimeout(() => setIsSearchInputOpen(false), 0);
                  }}
                >
                  <ContenedorHeader>
                    <SBuscador
                      inputRef={inputRef}
                      searchIcon={false}
                      nomenclator={nomenclator}
                      eleccion={elec}
                      page={page ? page : 'inicio'}
                      openTop={true}
                      onChangeCallback={() => {
                        setIsSearchInputOpen(false);
                        setMesa(null);
                      }}
                    />
                    <SearchButtonModal>
                      <FiSearch style={{ width: '50%', height: '50%' }} />
                    </SearchButtonModal>
                  </ContenedorHeader>

                  <ContenedorContent>
                    {busquedas && busquedas.length > 0 && (
                      <SectionBusqueda>
                        <TitleSection>Búsquedas recientes </TitleSection>
                        {busquedas.map((busqueda, index) => {
                          const dataFavoritos = getDataFavoritos({
                            busquedaItem: busqueda,
                            nomenclator,
                            page: constantes.nombreEleccion[elec],
                            currentElection: elec,
                          });

                          const genealogyNames = dataFavoritos.genealogyNames
                            .reverse()
                            .slice(0, 2);
                          return (
                            <ContenedorAmbito key={busqueda.c}>
                              <FiClock
                                color="#D8DFEA"
                                css={css`
                                  width: 1.5rem;
                                  height: 1.5rem;
                                  margin-right: 1rem;
                                `}
                              />
                              <TextoAmbito>
                                <SLink
                                  to={dataFavoritos.url}
                                  onClick={() => {
                                    setIsSearchInputOpen(false);
                                    setMesa(null);
                                  }}
                                >
                                  {`${genealogyNames.join(' - ')}${
                                    genealogyNames.length > 1
                                      ? ` - ${
                                          constantes.nombreLevel[busqueda.l]
                                        }`
                                      : ''
                                  }`}
                                </SLink>
                              </TextoAmbito>
                            </ContenedorAmbito>
                          );
                        })}
                      </SectionBusqueda>
                    )}
                    {busquedasSugeridas && busquedasSugeridas.length > 0 && (
                      <SectionBusqueda>
                        <TitleSection>Ámbitos sugeridos</TitleSection>
                        {busquedasSugeridas.map((busqueda, index) => {
                          const dataFavoritos = getDataFavoritos({
                            busquedaItem: busqueda,
                            nomenclator,
                            page: constantes.nombreEleccion[elec],
                            currentElection: elec,
                          });

                          const genealogyNames = dataFavoritos.genealogyNames
                            .reverse()
                            .slice(0, 2);
                          return (
                            <ContenedorAmbito key={busqueda.c}>
                              <FiSearch
                                style={{
                                  color: '#D8DFEA',
                                  width: '1.5rem',
                                  height: '1.5rem',
                                  marginRight: '1rem',
                                }}
                              />
                              <TextoAmbito>
                                <SLink
                                  to={dataFavoritos.url}
                                  onClick={() => {
                                    setIsSearchInputOpen(false);
                                    setMesa(null);
                                  }}
                                >
                                  {`${genealogyNames.join(' - ')}${
                                    genealogyNames.length > 1
                                      ? ` - ${
                                          constantes.nombreLevel[busqueda.l]
                                        }`
                                      : ''
                                  }`}
                                </SLink>
                              </TextoAmbito>
                            </ContenedorAmbito>
                          );
                        })}
                      </SectionBusqueda>
                    )}
                  </ContenedorContent>
                </StyledInlineDialog>
              </ContenedorModalFlecha>
            )}
          </SearchButtonContainer>
        </>
      )}
    </>
  );
});

const SearchButtonContainer = styled.div`
  position: relative;
`;

const SBuscador = styled(Buscador)`
  width: 100%;
  height: 7rem;
  z-index: 2050;
`;

const ContenedorHeader = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContenedorContent = styled.div`
  padding: 3rem;
`;

const ContenedorAmbito = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
`;

const StyledInlineDialog = styled(InlineDialog)`
  position: absolute;
  width: 800px;
  height: 428px;
  border-radius: 20px;
  background: #fff;
  overflow: hidden;
  margin: 0;
  padding: 0px;
  z-index: 1000;
  top: -300px;
  left: 120px;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.2);
  opacity: ${props => (props.isSearchInputOpen ? 1 : 0)};
  transform: scale(${props => (props.isSearchInputOpen ? 1 : 0.5)});
  transition: opacity 0.3s, transform 0.3s;

  @media (max-width: ${responsive.maxWidth.desktop}px) {
    width: 72vw;
  }
  @media (max-width: ${responsive.maxWidth.tablet}px) {
    width: 664px;
    height: 80vh;
  }
`;

const ContenedorModalFlecha = styled.div`
  position: relative;

  ::before {
    content: '';
    position: absolute;
    z-index: 10000001;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 30px 30px 0;
    border-color: #fff transparent transparent transparent;
    margin-top: -42px;
    left: 149%;
    transform: translateX(-50%);
    transform: rotate(90deg);
  }
`;

const SearchButtonModal = styled.div`
  width: 7rem;
  height: 7rem;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #215ccc;
  &:hover {
    background: rgb(28, 40, 61, 0.5);
    color: white;
  }
  &:disabled {
    background: dimgrey;
    cursor: not-allowed;
  }
`;

const TitleSection = styled.p`
  color: #aab0ba;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const TextoAmbito = styled.p`
  cursor: pointer;
  color: #164192;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
`;

const SLink = styled(LinkWithTop)`
  color: #164192;
  font-family: Montserrat;
`;

const SectionBusqueda = styled.div`
  margin-bottom: 2rem;
`;

export default BuscadorSideBar;
